<template>
  <div class="developer-view p-6">
    <header class="mb-6">
      <h1 class="text-3xl font-bold text-gray-800">Developer Tools</h1>
      <p class="text-gray-600 mt-2">
        Advanced tools and utilities for system administration and maintenance
      </p>
    </header>

    <Tabs value="0">
      <TabList>
        <Tab value="0">Migrations</Tab>
        <Tab value="1">Travel Buddy Simulator</Tab>
        <Tab value="2">Level goal repair</Tab>
        <Tab value="3">360mindset dimension fix</Tab>
        <Tab value="4">Empty dimension repair</Tab>
        <Tab value="5">KSS series config</Tab>
      </TabList>
      <TabPanels>
        <TabPanel value="0">
          <MigrationsTab />
        </TabPanel>
        <TabPanel value="1">
          <TravelBuddySimulatorTab />
        </TabPanel>
        <TabPanel value="2">
          <LevelGoalRepairTab />
        </TabPanel>
        <TabPanel value="3">
          <Mindset360DimensionCorrectionTab />
        </TabPanel>
        <TabPanel value="4">
          <EmptyDimensionRepairTab />
        </TabPanel>
        <TabPanel value="5">
          <KssSeriesConfigMigrationTab />
        </TabPanel>
      </TabPanels>
    </Tabs>
  </div>
</template>

<script>
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import MigrationsTab from './developer/MigrationsTab.vue';
import TravelBuddySimulatorTab from './developer/TravelBuddySimulatorTab.vue';
import LevelGoalRepairTab from './developer/LevelGoalRepairTab.vue';
import Mindset360DimensionCorrectionTab from './developer/Mindset360DimensionCorrectionTab.vue';
import EmptyDimensionRepairTab from './developer/EmptyDimensionRepairTab.vue';
import KssSeriesConfigMigrationTab from './developer/KssSeriesConfigMigrationTab.vue';

export default {
  name: 'DeveloperView',
  components: {
    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    MigrationsTab,
    TravelBuddySimulatorTab,
    LevelGoalRepairTab,
    Mindset360DimensionCorrectionTab,
    EmptyDimensionRepairTab,
    KssSeriesConfigMigrationTab,
  },
};
</script>

<style scoped>
.developer-view {
  min-height: 100%;
}
</style>
